import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "box-center-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "box-center-wrapper pa-2"
}

import Device from "@src/components/Device.vue";
import { onMounted, ref } from "vue";
import Toolbar from "@src/components/Toolbar.vue";
import "@style/documentation.scss";
import DeviceConfigurator from "@src/modules/DeviceConfigurator/DeviceConfigurator.vue";
import devicePresets from "@src/config/devicePresets";
import defineDeviceState from "@src/composables/defineDeviceState";
import Documentation from "@src/modules/Documentation/components/Documentation.vue";
import AboutModal from "@src/components/AboutModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainApp',
  setup(__props) {

const deviceState = defineDeviceState();

const isDeviceConfiguratorVisible = ref(false);
const isDocumentationVisible = ref(false);
const isAboutModalVisible = ref(false);

onMounted(() => {
  deviceState.buildFromParams(
    devicePresets[0].width,
    devicePresets[0].height,
    devicePresets[0].modules,
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Device)
    ]),
    (isDocumentationVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Documentation)
        ]))
      : _createCommentVNode("v-if", true),
    (isDeviceConfiguratorVisible.value)
      ? (_openBlock(), _createBlock(DeviceConfigurator, {
          key: 1,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (isDeviceConfiguratorVisible.value = false))
        }))
      : _createCommentVNode("v-if", true),
    (isAboutModalVisible.value)
      ? (_openBlock(), _createBlock(AboutModal, {
          key: 2,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (isAboutModalVisible.value = false))
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(Toolbar, {
      onCreateConfiguration: _cache[2] || (_cache[2] = ($event: any) => (isDeviceConfiguratorVisible.value = true)),
      onDocumentation: _cache[3] || (_cache[3] = ($event: any) => (isDocumentationVisible.value = !isDocumentationVisible.value)),
      onAbout: _cache[4] || (_cache[4] = ($event: any) => (isAboutModalVisible.value = true))
    })
  ], 64 /* STABLE_FRAGMENT */))
}
}

})